import React, { useState } from "react";
import { useForm, ValidationError } from "@formspree/react";


function ContactForm() {
  const [state, handleSubmit] = useForm("xeoqqkqd");
  const [emailError, setEmailError] = useState(false);
  const [messageError, setMessageError] = useState(false);
  const [formError, setFormError] = useState("");

  const validateForm = (event) => {
    event.preventDefault();
    const email = event.target.email.value;
    const message = event.target.message.value;

    // Check if fields are empty
    if (!email || !message) {
      setEmailError(!email);
      setMessageError(!message);
      setFormError("Veuillez remplir tous les champs.");
      return; // Prevent form submission if fields are empty
    }

    // If both fields are filled, clear errors and submit the form
    setEmailError(false);
    setMessageError(false);
    setFormError("");
    handleSubmit(event);
  };

  // Display success message and refresh the page
  if (state.succeeded) {
    setTimeout(() => window.location.reload(), 2000); // Refresh page after 2 seconds
    return (
      <div id="ContactForm" className="relative bg-[#082028] py-12 md:py-20">
        {" "}
        {/* Updated background color */}
        <div className="absolute inset-0 z-0">
          {/* You can add a background image here if needed */}
        </div>
        <div className="relative z-10 container mx-auto flex flex-col items-center px-6 md:px-12">
          <div className="w-full md:w-2/3 lg:w-1/2 bg-white bg-opacity-90 p-6 md:p-10 rounded-lg shadow-lg">
            <p className="text-[#D0B070] text-xl font-semibold mb-2">Merci !</p>{" "}
            {/* Updated text color */}
            <h1 className="text-3xl md:text-5xl font-bold mb-4 text-[#D0B070]">
              Message envoyé avec succès
            </h1>{" "}
            {/* Updated text color */}
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div id="ContactForm" className="relative bg-[#082028] py-12 md:py-20">
        {" "}
        {/* Updated background color */}
        <div className="absolute inset-0 z-0">
          {/* You can add a background image here if needed */}
        </div>
        <div className="relative z-10 container mx-auto flex flex-col items-center px-6 md:px-12">
          <div className="w-full md:w-2/3 lg:w-1/2 bg-[#07182E]  bg-opacity-90 p-6 md:p-10 rounded-lg shadow-lg">
            <p className="text-[#D0B070] md:text-2xl text-2xl font-semibold mb-2">
              Contactez-nous
            </p>{" "}
            {/* Updated text color */}
            <h1 className="text-xs md:text-5xl font-bold mb-4 text-[#D0B070]">
              Envoyez-nous un message
            </h1>{" "}
            {/* Updated text color */}
            <p className="text-gray-100 md:text-lg text-[12px] mb-4">
              Nous sommes ici pour répondre à vos questions et vous fournir plus
              d'informations sur nos services.
            </p>
            <form onSubmit={validateForm} className="space-y-6">
              <div>
                <label
                  htmlFor="email"
                  className="block md:text-xl text-[12px] text-gray-100 font-medium mb-2"
                >
                  Adresse E-mail
                </label>
                <input
                  id="email"
                  type="email"
                  name="email"
                  className={`w-full md:h-12 h-6 md:p-3 p-1 border-b-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#D0B070] ${
                    // Updated focus color
                    emailError ? "border-red-500" : ""
                  }`}
                />
                <ValidationError
                  prefix="Email"
                  field="email"
                  errors={state.errors}
                  className="text-red-500 mt-2"
                />
              </div>

              <div>
                <label
                  htmlFor="message"
                  className="block md:text-xl text-[12px] text-gray-100 font-medium mb-2"
                >
                  Message
                </label>
                <textarea
                  id="message"
                  name="message"
                  rows="5"
                  className={`w-full md:h-24 h-16 md:p-3 p-1 border-b-4 border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#D0B070] ${
                    // Updated focus color
                    messageError ? "border-red-500" : ""
                  }`}
                />
                <ValidationError
                  prefix="Message"
                  field="message"
                  errors={state.errors}
                  className="text-red-500 mt-2"
                />
              </div>

              {formError && <p className="text-red-500 text-xs">{formError}</p>}

              <div className="flex justify-start">
                <button
                  type="submit"
                  disabled={state.submitting}
                  className="bg-[#D0B070] md:text-xl text-[12px] hover:bg-yellow-500 text-black py-2 px-6 rounded-full" // Updated button color
                >
                  Envoyer
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default ContactForm;
